module.exports = __webpack_public_path__ + "img/beta-tile.642e60a.jpg";